export default __webpack_public_path__ + "static/media/frontoffice_quickguide.71a91161.pdf";